module.exports = __webpack_public_path__ + "static/media/Credit-sales.1705f6fb.svg";